import React from 'react'
import { getImages } from '../const'

const AlertModal = ({setShowAlertModal}) => {
  return (
    <>
        <div className='modal-content p-5'>
            <div className='text-center'>
                <img src={getImages('circle-check.png')}/>
            </div>
            <div className='md-title text-center mt-5 mb-3'>Search Saved</div>
            <div className='text-center'>
                <button type='button' className='red-btn w-206' onClick={()=> setShowAlertModal(false)}>OK</button>
            </div>
        </div>
    </>
  )
}

export default AlertModal